"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallNotification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const analytics_1 = require("@streem/analytics");
const ui_react_1 = require("@streem/ui-react");
const media_1 = require("../../media");
const logger_1 = require("../../util/logger");
const use_reservation_audio_1 = require("../../hooks/use_reservation_audio");
const toolbox_1 = require("@streem/toolbox");
const decline_call_confirmation_1 = require("./decline_call_confirmation");
const CallNotification = ({ roomInvitation, onAnswer, onReject, brandSettings, showReservationCallDetailYn = false, }) => {
    var _a;
    const { pauseReservationAudio } = (0, use_reservation_audio_1.useReservationAudio)();
    const [hasExpertClickedAnswerYn, setHasExpertClickedAnswerYn] = (0, react_1.useState)(false);
    const [isDeclineCallModalDisplaying, setIsDeclineModalDisplaying] = (0, react_1.useState)(false);
    const disableNotificationButtons = isDeclineCallModalDisplaying || hasExpertClickedAnswerYn;
    const handleOnEnter = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        function playRingtoneAudio() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield media_1.audio.playRingtoneAudio();
                }
                catch (error) {
                    logger_1.logger.warn(`Failed to play incoming call ringtone for invitationId=${roomInvitation.id}, roomId=${roomInvitation.roomId}, from userId=${roomInvitation.fromUserId}, preferredAudioOutputId=${(0, toolbox_1.getPreferredAudioOutputId)()}`, error);
                }
            });
        }
        logger_1.logger.info(`Pausing reservation ringtone audio for invitation: ${roomInvitation.id}, room: ${roomInvitation.roomId}, from user: ${roomInvitation.fromUserId}`);
        pauseReservationAudio();
        logger_1.logger.info(`Playing incoming call ringtone audio for invitation: ${roomInvitation.id}, room: ${roomInvitation.roomId}, from user: ${roomInvitation.fromUserId}`);
        yield playRingtoneAudio();
    }), [
        pauseReservationAudio,
        roomInvitation.fromUserId,
        roomInvitation.id,
        roomInvitation.roomId,
    ]);
    const handleOnExit = (0, react_1.useCallback)(() => {
        logger_1.logger.info(`Pausing incoming call ringtone audio for invitation: ${roomInvitation.id}, room: ${roomInvitation.roomId}, from user: ${roomInvitation.fromUserId}`);
        media_1.audio.pauseRingtoneAudio();
    }, [roomInvitation.fromUserId, roomInvitation.id, roomInvitation.roomId]);
    const handleOnAnswer = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setHasExpertClickedAnswerYn(true);
        logger_1.logger.info(`Clicked Answer for invitationId=${roomInvitation.id}, roomId=${roomInvitation.roomId}, from userId=${roomInvitation.fromUserId}`);
        yield onAnswer();
    }), [onAnswer, roomInvitation.fromUserId, roomInvitation.id, roomInvitation.roomId]);
    const handleOnDecline = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsDeclineModalDisplaying(true);
        logger_1.logger.info('Displaying Decline Call Modal');
    });
    const handleOnDeclineConfirmationSelected = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        (0, analytics_1.recordElementClicked)('decline-confirmation-modal-decline-button');
        try {
            setIsDeclineModalDisplaying(false);
            logger_1.logger.info(`Clicked Reject for invitationId=${roomInvitation.id}, roomId=${roomInvitation.roomId}, from userId=${roomInvitation.fromUserId}`);
            yield onReject();
        }
        catch (e) {
            logger_1.logger.error(`Failed to reject invitationId=${roomInvitation.id}, roomId=${roomInvitation.roomId}, from userId=${roomInvitation.fromUserId}`);
        }
    }), [onReject, roomInvitation.fromUserId, roomInvitation.id, roomInvitation.roomId]);
    const handleOnDeclineConfirmationCancel = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        logger_1.logger.info(`Clicked cancel for reject confirmation for invitationId=${roomInvitation.id}, roomId=${roomInvitation.roomId}, from userId=${roomInvitation.fromUserId}`);
        (0, analytics_1.recordElementClicked)('decline-confirmation-modal-cancel-button');
        setIsDeclineModalDisplaying(false);
    }), [roomInvitation.fromUserId, roomInvitation.id, roomInvitation.roomId]);
    // Handles customer canceling call before expert can answer.
    (0, react_1.useEffect)(() => {
        return () => {
            logger_1.logger.info('CallNotification component unmounted');
            // If audio wasn't successfully paused by the onExit or the customer cancelled the call
            // before expert could answer, call the pause ringtone function
            if (!media_1.audio.ringtoneAudioPaused) {
                logger_1.logger.info('Pausing ringtone');
                media_1.audio.pauseRingtoneAudio();
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (disableNotificationButtons) {
            logger_1.logger.info(`Call notificatoin buttons have been disabled isDeclineCallModalDisplaying=${isDeclineCallModalDisplaying}, hasExpertClickedAnswerYn=${hasExpertClickedAnswerYn}`);
        }
    }, [disableNotificationButtons, isDeclineCallModalDisplaying, hasExpertClickedAnswerYn]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showReservationCallDetailYn ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IncomingCallNotification, { open: roomInvitation.status === 'PENDING', shouldDisableButtons: disableNotificationButtons, onEnter: handleOnEnter, onExit: handleOnExit, onAnswer: handleOnAnswer, onDecline: handleOnDecline, customerName: roomInvitation.fromUser.name, brandName: brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.brandName, brandLogoUrl: brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.brandLogoUrl, brandPrimaryColor: (_a = brandSettings === null || brandSettings === void 0 ? void 0 : brandSettings.customTheme) === null || _a === void 0 ? void 0 : _a.primaryColor }) })) : ((0, jsx_runtime_1.jsx)(ui_react_1.LegacyIncomingCallNotification, { open: roomInvitation.status === 'PENDING', fromUserId: roomInvitation.fromUserId.toString(), fromUserName: roomInvitation.fromUser.name || 'user', referenceId: roomInvitation.roomId.toString(), onEnter: handleOnEnter, onExit: handleOnExit, onAnswer: handleOnAnswer, onReject: handleOnDecline, shouldDisableButtons: disableNotificationButtons })), (0, jsx_runtime_1.jsx)(decline_call_confirmation_1.DeclineCallConfirmation, { isOpen: isDeclineCallModalDisplaying, onCancel: handleOnDeclineConfirmationCancel, handleDeclineCall: handleOnDeclineConfirmationSelected })] }));
};
exports.CallNotification = CallNotification;
//# sourceMappingURL=call_notification.js.map